import { SwitchTemplate } from '../../components/switch/c-switch.template'

export const BookingAppliesToAllParticipantsTemplate = (d) => {
  const result = `${d.choosePerPerson
    ? SwitchTemplate(Object.assign({}, d.choosePerPerson.switchInfo))
    : ''}
  `
  return result
}
